import { FC, MouseEvent } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography, Divider, Button } from "@material-ui/core";
import Tabs from 'src/components/Tabs'
import { useStore, connect } from "src/store/connect";
import { ReactComponent as AlertIcon } from 'src/assets/alert.svg';
import { ReactComponent as ArrowLeftIcon } from 'src/assets/arrow-left.svg';
import { ReactComponent as WhatsAppIcon } from "src/assets/whatsapp.svg";
import { WHATSAPP_BASE_URL, WHATSAPP_PHONE_NUMBER } from "src/config/constants";
import mixpanel from "mixpanel-browser";

interface HeaderProps {
  onStartSimulation: (event: MouseEvent) => void;
  onDeploy: (event: MouseEvent) => void;
};

const Header: FC<HeaderProps> = ({ onStartSimulation, onDeploy }: HeaderProps) => {
    const classes = useStyles();
    const state = useStore();

    const onOpenInWhatsapp = () => {
      const url = `${WHATSAPP_BASE_URL}/${WHATSAPP_PHONE_NUMBER}?text=${state.flow.inboundMessage}`
      mixpanel.track('whatsapp_link_clicked', {button_used: 'header'})

      window.open(encodeURI(url), '_blank');
    }

    return (
      <div className={classes.root}>
        <ArrowLeftIcon className={classes.justifyCenter}/>
        <Divider orientation="vertical" flexItem />
        <Tabs />
        <Typography
          className={classes.title}
          onClick={() => mixpanel.track('project_name_clicked')}
        >
          Tu primer proyecto
        </Typography>
        <AlertIcon onClick={() => mixpanel.track('warning_icon_clicked')} />
        <div className={classes.ctaContainers}>
          <Button
            className={state.flow.isDeployed ? classes.secondaryButton : classes.primaryButton}
            variant="contained"
            onClick={(e) => onStartSimulation(e)}>
              Simular
          </Button>
          {state.flow.isDeployed ? (
            <Button className={classes.whatsAppButton} variant="contained" onClick={onOpenInWhatsapp}>
              <WhatsAppIcon className={classes.whatsAppIcon} />
              <Typography> Ver en Whatsapp </Typography>
            </Button>
          ) : (
          <Button
            className={classes.secondaryButton}
            variant="contained"
            onClick={(e) => onDeploy(e)}
            color='primary'
          >
              Desplegar
          </Button>
          )}
        </div>
      </div>
    );
};

Header.defaultProps = { };

export default connect(Header);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: "24px 38px 24px 20px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 10fr 5fr 5fr 8fr",
    alignItems: "center",
    zIndex: 100,
    position: "relative",
    background: "#fff",
  },
  title: {
    fontSize: "19px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    justifySelf: "end",
  },
  primaryButton: {
    textTransform: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 6px 0 rgba(68, 83, 226, 0.29)",
    backgroundColor: "#37ee8c",
    fontSize: "14px",
    fontWeight: 600,
    marginRight: "14px",
    width: "125px",

    "&:hover": {
        backgroundColor: "#37ee8c",
    }
  },
  secondaryButton: {
    textTransform: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 6px 0 rgba(68, 83, 226, 0.29)",
    fontSize: "14px",
    fontWeight: 500,
    color: "#ffffff",
    backgroundColor: "#0468FD",
    padding: "10px",
    width: "125px",
    height: "40px",
    marginRight: "14px",

    "&:hover": {
        backgroundColor: "#0468FD",
    }
  },
  justifyCenter: {
    justifySelf: "center",
  },
  ctaContainers: {
    justifySelf: "end",
    display: "flex",
    alignItems: "center",
  },
  whatsAppButton: {
    textTransform: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 6px 0 rgba(68, 83, 226, 0.29)",
    backgroundColor: "#37ee8c",
    fontSize: "14px",
    fontWeight: 600,
    marginRight: "14px",
    width: "194px",
    height: "40px",
    padding: "10px",

    "&:hover": {
      backgroundColor: "#37ee8c",
    },
  },
  whatsAppIcon: {
    marginRight: "10px",
    width: "21px",
  },
}));
